
export const weekArray:string[] = ["일", "월", "화", "수", "목", "금", "토"];

export const timeIn24Hours:string[] = Array.from({ length: 24 }, (_, index) => {
  const hour = index.toString().padStart(2, '0');
  return `${hour}`;
});

export const fileType:string[] = ["image", "video", "text"];


//전달 받은 날짜 yyyy-mm-dd
export const formatDateToString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


//전달 받은 날짜 yyyy-mm
export const formatYMToString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

// 현재 시간
export const getCurrentYYMMDD = () => {
  const currentDate = new Date().toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).replaceAll('.', '').replaceAll(' ', '-');
  return currentDate;
};

//전달 받은 날짜에 Year +/-  yyyy-mm-dd
export const calculYearDateToString = (date: Date, year: number): string => {
  const baseDate = new Date(date);
  baseDate.setFullYear(baseDate.getFullYear() + year);
  const calculDate = baseDate.toISOString().split('T')[0];
  return calculDate;
};

//전달 받은 날짜에 Month +/-  yyyy-mm-dd
export const calculMonthDateToString = (date: Date, month: number): string => {
  const baseDate = new Date(date);
  baseDate.setMonth(baseDate.getMonth() + month);
  const calculDate = baseDate.toISOString().split('T')[0];
  return calculDate;
};

//전달 받은 날짜에 Day +/-  yyyy-mm-dd
export const calculDayDateToString = (date: Date, day: number): string => {
  const baseDate = new Date(date);
  baseDate.setDate(baseDate.getDate() + day);
  const calculDate = baseDate.toISOString().split('T')[0];
  return calculDate;
};

//현재 시간 yyyy-mm-dd hh:mm:ss
export const getCurrentDateTime = (): string => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');
  const hours = currentDate.getHours().toString().padStart(2, '0');
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const seconds = currentDate.getSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

//현재 날짜 yyyy-mm-dd 23:59:59
export const getCurrentDate = (): string => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day} 23:59:59`;
};

//현재 날짜의 1일날짜를 가져오는 함수
export const getFirstDateOfMonth = (): string => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  return `${year}-${month}-01 00:00:00`;
};

//현재 날짜의 마지막일자를 가져오는 함수
// 2021-02-01 -> 2021-02-28 23:59:59
export const getLastDateOfMonth = (dateStr: string): string => {
  const [year, month] = dateStr.split('-').map(Number); // 날짜 문자열을 분리하여 숫자로 변환
  const lastDate = new Date(year, month, 0);
  const monthStr = month.toString().padStart(2, '0');

  return `${year}-${monthStr}-${lastDate.getDate()} 23:59:59`;
};


// 이전 날짜 가져오는 함수 yyyy-mm-dd hh:mm:ss
export const  getPreviousDateFromDate = (baseDateStr: string, days: number): string => {
  // 문자열을 Date 객체로 변환
  const baseDate = new Date(baseDateStr);

  // 주어진 날짜를 기준으로 이전 날짜 계산
  const previousDate = new Date(baseDate);
  previousDate.setDate(previousDate.getDate() - days);

  // 날짜와 시간을 문자열로 변환
  const year = previousDate.getFullYear();
  const month = (previousDate.getMonth() + 1).toString().padStart(2, "0");
  const date = previousDate.getDate().toString().padStart(2, "0");
  const hours = previousDate.getHours().toString().padStart(2, "0");
  const minutes = previousDate.getMinutes().toString().padStart(2, "0");
  const seconds = previousDate.getSeconds().toString().padStart(2, "0");

  return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
};

// 2024-02-20T16:10:25.000Z -> 2024-02-20 16:10:25
export const formattedDateTime = (date: string): string => {
  const originalDate = new Date(date);
  originalDate.setHours(originalDate.getHours() - 9);
  const year = originalDate.getFullYear();
  const month = String(originalDate.getMonth() + 1).padStart(2, "0");
  const day = String(originalDate.getDate()).padStart(2, "0");
  const hours = String(originalDate.getHours()).padStart(2, "0");
  const minutes = String(originalDate.getMinutes()).padStart(2, "0");
  const seconds = String(originalDate.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// 밀리초 -> yymmdd hh:mm:ss
export const formattedMillisToDateTime = (millis: number): string => {
  const currentDate = new Date(millis);
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');
  const hours = currentDate.getHours().toString().padStart(2, '0');
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const seconds = currentDate.getSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// A/S 접수 상태
export const afterServiceStateType = ["대기", "접수완료", "진행중", "처리완료", "답변완료", "취소완료"];
// A/S 접수 유형
export const afterServiceType = ["APP", "카메라", "녹화기", "웹관제", "사용법", "기타"];

// 녹화기 이벤트
export const contractStatusLabel = [
  { code: "A", name: "승인대기" },
  { code: "G", name: "보류" },
  { code: "B", name: "승인" },
  { code: "C", name: "계약중" },
  { code: "D", name: "중지" },
  { code: "E", name: "해약" },
  { code: "F", name: "만료" },
]

// 녹화기 이벤트
export const eventLabels: Record<string, string> = {
  field_detection: "침입 감지",
  line_detection: "경계선 통과 감지",
  thermal: "열 감지",
  audio_exception: "비정상 오디오 감지",
  guard_change: "경계 설정 변화",
  sensor_on: "센서 ON",
  env_sensor: "환경 센서",
  fall_down: "쓰러짐",
  loitering: "배회(장기체류)",
  smog: "연기/화재 감지"
};

export const bankList = [
  { code: "001", name: "한국은행" },
  { code: "002", name: "산업은행" },
  { code: "003", name: "기업은행" },
  { code: "004", name: "국민은행" },
  { code: "005", name: "외환은행" },
  { code: "007", name: "수협은행" },
  { code: "008", name: "수출입은행" },
  { code: "011", name: "농협은행" },
  { code: "012", name: "농협회원조합" },
  { code: "020", name: "우리은행" },
  { code: "023", name: "SC제일은행" },
  { code: "026", name: "서울은행" },
  { code: "027", name: "한국씨티은행" },
  { code: "031", name: "iM뱅크(대구)" },
  { code: "032", name: "부산은행" },
  { code: "034", name: "광주은행" },
  { code: "035", name: "제주은행" },
  { code: "037", name: "전북은행" },
  { code: "039", name: "경남은행" },
  { code: "045", name: "새마을금고연합회" },
  { code: "048", name: "신협중앙회" },
  { code: "050", name: "상호저축은행" },
  { code: "051", name: "기타 외국계은행" },
  { code: "052", name: "모건스탠리은행" },
  { code: "054", name: "HSBC은행" },
  { code: "055", name: "도이치은행" },
  { code: "056", name: "알비에스피엘씨은행" },
  { code: "057", name: "제이피모간체이스은행" },
  { code: "058", name: "미즈호코퍼레이트은행" },
  { code: "059", name: "미쓰비시도쿄UFJ은행" },
  { code: "060", name: "BOA" },
  { code: "061", name: "비엔피파리바은행" },
  { code: "062", name: "중국공상은행" },
  { code: "063", name: "중국은행" },
  { code: "064", name: "산림조합" },
  { code: "065", name: "대화은행" },
  { code: "071", name: "우체국" },
  { code: "076", name: "신용보증기금" },
  { code: "077", name: "기술신용보증기금" },
  { code: "081", name: "하나은행" },
  { code: "088", name: "신한은행" },
  { code: "089", name: "케이뱅크" },
  { code: "090", name: "카카오뱅크" },
  { code: "092", name: "토스뱅크" },
  { code: "093", name: "한국주택금융공사" },
  { code: "094", name: "서울보증보험" },
  { code: "095", name: "경찰청" },
  { code: "099", name: "금융결제원" },
  { code: "209", name: "동양종합금융증권" },
  { code: "218", name: "현대증권" },
  { code: "230", name: "미래에셋증권" },
  { code: "238", name: "대우증권" },
  { code: "240", name: "삼성증권" },
  { code: "243", name: "한국투자증권" },
  { code: "247", name: "NH투자증권" },
  { code: "261", name: "교보증권" },
  { code: "262", name: "하이투자증권" },
  { code: "263", name: "에이치엠씨투자증권" },
  { code: "264", name: "키움증권" },
  { code: "265", name: "이트레이드증권" },
  { code: "266", name: "SK증권" },
  { code: "267", name: "대신증권" },
  { code: "268", name: "솔로몬투자증권" },
  { code: "269", name: "한화증권" },
  { code: "270", name: "하나대투증권" },
  { code: "271", name: "토스증권" },
  { code: "278", name: "신한금융투자" },
  { code: "279", name: "동부증권" },
  { code: "280", name: "유진투자증권" },
  { code: "287", name: "메리츠증권" },
  { code: "289", name: "엔에이치투자증권" },
  { code: "290", name: "부국증권" },
  { code: "291", name: "신영증권" },
  { code: "292", name: "엘아이지투자증권" }
];

export const cardCompanyList = [
  { code: "01", name: "BC카드" },
  { code: "02", name: "KB국민카드" },
  { code: "03", name: "하나(외환)카드" },
  { code: "04", name: "삼성카드" },
  { code: "06", name: "신한카드" },
  { code: "07", name: "현대카드" },
  { code: "08", name: "롯데카드" },
  { code: "09", name: "한미카드" },
  { code: "10", name: "신세계한미카드" },
  { code: "11", name: "씨티카드" },
  { code: "12", name: "NH채움카드" },
  { code: "13", name: "수협카드" },
  { code: "14", name: "신협카드" },
  { code: "15", name: "우리BC카드" },
  { code: "16", name: "하나카드" },
  { code: "17", name: "우리카드" },
  { code: "21", name: "광주카드" },
  { code: "22", name: "전북카드" },
  { code: "23", name: "제주카드" },
  { code: "24", name: "산은캐피탈카드" },
  { code: "25", name: "해외비자카드" },
  { code: "26", name: "해외마스터카드" },
  { code: "27", name: "해외다이너스카드" },
  { code: "28", name: "해외AMX카드" },
  { code: "29", name: "해외JCB카드" },
  { code: "31", name: "SK-OK캐시백" },
  { code: "32", name: "우체국카드" },
  { code: "33", name: "저축은행카드" },
  { code: "34", name: "은련카드" },
  { code: "35", name: "새마을금고카드" },
  { code: "36", name: "KDB산업카드" },
  { code: "37", name: "카카오뱅크카드" },
  { code: "38", name: "케이뱅크카드" },
  { code: "39", name: "PAYCO 포인트" },
  { code: "40", name: "카카오머니" },
  { code: "41", name: "SSG머니" },
  { code: "42", name: "네이버페이포인트" },
  { code: "44", name: "토스뱅크카드" },
  { code: "46", name: "토스머니" }
];